<template>
  <v-layout justify-end>
  <v-list-tile-action>
    <v-tooltip left>
      <v-select slot="activator"
                :items="permissions"
                :hide-details="true"
                :disabled="isBlocked"
                :loading="permissionLoading"
                class="pb-0 permission-select"
                @input="updateItemPermission(item, item.permission, type+'s')"
                v-model="item.permission">
        <template slot="selection" slot-scope="data">
          <v-icon>{{data.item.icon}}</v-icon>
        </template>
        <template slot="item" slot-scope="data">
          <v-list-tile-avatar><v-icon>{{data.item.icon}}</v-icon></v-list-tile-avatar>
          <v-list-tile-content>{{$tf(data.item.text)}}</v-list-tile-content>
        </template>
      </v-select>
      <span>{{$tf('Permission')}}</span>
    </v-tooltip>
  </v-list-tile-action>

  <v-list-tile-action>
    <v-tooltip left>
      <v-btn slot="activator"
             icon
             v-ripple
             :disabled="isBlocked"
             :loading="unshareLoading"
             @click="permissions.length < 3 ? null : stopSharingWithOne(item, type)">
        <v-icon color="grey">stop_screen_share</v-icon>
      </v-btn>
      <span>{{$tf('Stop sharing')}}</span>
    </v-tooltip>
  </v-list-tile-action>
  </v-layout>
</template>

<script>
  export default {
    name: 'SharedWithActions',
    props: {
      permissions: {
        type: Array,
        required: true
      },
      item: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      fileId: {
        type: Number,
        required: true
      },
      disabled: {
        type: Boolean
      }
    },
    data () {
      return {
        permissionLoading: false,
        unshareLoading: false
      }
    },
    computed: {
      isBlocked () {
        return this.disabled || this.permissionLoading || this.unshareLoading
      }
    },
    methods: {
      itemID (item, type) {
        switch (type) {
          case 'account':
          case 'accounts':
            return item.account_id
          case 'group':
          case 'groups':
            return item.group_id
          case 'organization':
          case 'organizations':
            return item.id
          case 'token':
          case 'guest':
          case 'guests':
            return item.token_id ? item.token_id.toString() : item.token_id
          default:
            throw new Error('Unknonw type ' + type)
        }
      },
      itemEndpoint (type) {
        switch (type) {
          case 'token':
          case 'guest':
          case 'guests':
            return 'token'
          default:
            return type
        }
      },
      stopSharingWithOne (item, type) {
        this.unshareLoading = true
        this.$emit('block', true)
        const unshareLoadingTimeout = setTimeout(() => {
          if (this.unshareLoading) {
            this.$emit('alert', true)
          }
        }, 2000)
        this.$store.state.shareFile.endpointChild = this.itemEndpoint(type)
        this.$store.dispatch('shareFile/delete', {
          idParent: this.fileId,
          idChild: this.itemID(item, type),
          params: {}
        }).then(response => {
          this.unshareLoading = false
          this.$emit('block', false)
          clearTimeout(unshareLoadingTimeout)
        }).catch(err => {
          if (err.status === undefined || (err.status !== 502 && err.status !== 0)) {
            this.unshareLoading = false
            this.$emit('block', false)
            clearTimeout(unshareLoadingTimeout)
            setTimeout(() => {
              this.$emit('alert', false)
            }, 3000)
          } else {
            this.$store.dispatch('feedback/addSnack', { text: 'Unsharing will take a few moments' })
          }
        })
      },
      updateItemPermission (item, permission, type) {
        this.permissionLoading = true
        this.$emit('block', true)
        let itemID
        switch (type) {
          case 'groups':
            itemID = 'group/' + this.itemID(item, type)
            type = 'actors'
            break
          case 'organizations':
            itemID = 'organization/' + this.itemID(item, type)
            type = 'actors'
            break
          default:
            itemID = this.itemID(item, type.substring(0, type.length - 1))
        }

        const params = {
          accounts: [],
          guests: [],
          actors: [],
          permission: permission
        }

        params[type].push(itemID)
        this.$store.dispatch('shareFile/add', {
          id: this.fileId,
          params: params
        }).then(() => {
          this.$store.dispatch('feedback/addSnack', {text: 'Permission updated'})
          this.permissionLoading = false
          this.$emit('block', false)
        }).catch(response => {
          if (response.status === undefined || (response.status !== 502 && response.status !== 0)) {
            console.error(response)
            this.$store.dispatch('feedback/addSnack', {text: 'Something went wrong'})
            this.permissionLoading = false
            this.$emit('block', false)
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/share/SharedWithActions.vue